import { Subscriptions } from "@/pages/Subscriptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/subscriptions")({
  component: Subscriptions,
});
